import purchase from '@/api/purchase-order-v2/order'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'
import { join, isEmpty, split } from 'lodash'

export const state = {
  ...baseState,
  vendor_id: [],
  location_id: [],
  dateRange: [
    moment()
      .add(-7, 'days')
      .format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ],
  formViewDatas: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_LOCATION_ID(state, data) {
    state.location_id = data
  },
  SET_VENDOR_ID(state, data) {
    state.vendor_id = data
  },
  CLEAR_SETUP(state) {
    state.formViewDatas = []
  },
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewDatas[el] = data[el];
      });
    }
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          vendor_id: context.state.vendor_id,
          search: context.state.search,
          location_id: context.state.location_id,
          date_between: join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return purchase.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return purchase.store(data)
  },
  update(context, { id, data }) {
    return purchase.update(id, data)
  },
  async find(context, id) {
    if (isEmpty(context.state.edit_data)) {
      let response = await purchase.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return purchase.destroy(id)
  },
  printPdf(context, id) {
    return purchase.printPdf(id)
  },
  downloadTemplate(context, data) {
    return purchase.downloadTemplate(data)
  },
  async getFormViewModel(context, { params, index }) {
    let response = await purchase.formViewModel({ params: params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  }
}
